import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        Affiliate Disclaimer: This site contains affiliate links to Amazon.
        We may receive a commission for purchases made through these links.
      </p>
    </footer>
  );
};

export default Footer;